module.exports = __webpack_public_path__ + "img/ic-back.a57fa656.svg";